import { Phone, MapPin, Clock, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const WHATSAPP_NUMBER = "491798067007";

const quickLinks = [
  { label: 'Leistungen', href: '#leistungen' },
  { label: 'Über uns', href: '#ueber-uns' },
  { label: 'So funktioniert\'s', href: '#prozess' },
  { label: 'Bewertungen', href: '#bewertungen' },
  { label: 'Standort', href: '#standort' },
  { label: 'FAQ', href: '#faq' },
];

const services = [
  'Gebrauchtwagen Ankauf',
  'Unfallwagen Ankauf',
  'Fahrzeuge mit Motorschaden',
  'Autos ohne TÜV',
  'Firmenwagen Ankauf',
  'Exportfahrzeuge',
];

export const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="footer" className="bg-tiktok-surface border-t border-white/10">
      {/* Main Footer */}
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl md:text-3xl font-black mb-4">
              <span className="bg-gradient-to-r from-tiktok-cyan via-white to-tiktok-pink bg-clip-text text-transparent">
                PKW Ankauf 24/7
              </span>
            </h3>
            <p className="text-gray-400 text-sm mb-6">
              Ihr Partner für schnellen und fairen Autoankauf in ganz Deutschland und Europa.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4">Navigation</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="flex items-center gap-2 text-gray-400 hover:text-tiktok-cyan transition-colors text-sm"
                  >
                    <ChevronRight className="w-4 h-4" />
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4">Leistungen</h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <span className="flex items-center gap-2 text-gray-400 text-sm">
                    <ChevronRight className="w-4 h-4 text-tiktok-pink" />
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4">Kontakt</h4>
            <ul className="space-y-4">
              <li>
                <a href={`tel:+${WHATSAPP_NUMBER}`} className="flex items-start gap-3 text-gray-400 hover:text-tiktok-cyan transition-colors">
                  <Phone className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">+49 179 8067007</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-gray-400">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">
                    Deutschlandweit &<br />
                    Europaweit
                  </span>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-3 text-gray-400">
                  <Clock className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">
                    24/7 Erreichbar<br />
                    Rund um die Uhr
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 md:px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500 text-center md:text-left">
              © {new Date().getFullYear()} PKW Ankauf 24/7. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/impressum"
                data-testid="footer-impressum"
                className="text-sm text-gray-500 hover:text-white transition-colors"
              >
                Impressum
              </Link>
              <Link
                to="/datenschutz"
                data-testid="footer-datenschutz"
                className="text-sm text-gray-500 hover:text-white transition-colors"
              >
                Datenschutz
              </Link>
              <button
                onClick={() => {
                  localStorage.removeItem('cookiesAccepted');
                  window.location.reload();
                }}
                data-testid="footer-cookie-settings"
                className="text-sm text-gray-500 hover:text-white transition-colors"
              >
                Cookie-Einstellungen
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
